var map = {
	"./applicationdelivered_icon.svg": 4985,
	"./applications-dark-hover.svg": 9708,
	"./applications-dark.svg": 9889,
	"./applications-light-hover.svg": 5438,
	"./applications-light.svg": 6487,
	"./architecture-dark-hover.svg": 4420,
	"./architecture-dark.svg": 1097,
	"./architecture-light-hover.svg": 2022,
	"./architecture-light.svg": 431,
	"./centrico-logo-dark.svg": 9823,
	"./centrico-logo-light.svg": 3485,
	"./core-banking-dark-hover.svg": 2679,
	"./core-banking-dark.svg": 7014,
	"./core-banking-light-hover.svg": 5911,
	"./core-banking-light.svg": 6182,
	"./credits-dark-hover.svg": 3215,
	"./credits-dark.svg": 590,
	"./credits-icon-dark-hover.svg": 4635,
	"./credits-icon-dark.svg": 9290,
	"./credits-light-hover.svg": 3855,
	"./credits-light.svg": 6718,
	"./cybersecurity-dark-hover.svg": 2142,
	"./cybersecurity-dark.svg": 3495,
	"./cybersecurity-light-hover.svg": 1504,
	"./cybersecurity-light.svg": 4389,
	"./data_management_img_dark.svg": 6320,
	"./datamanagement-dark-hover.svg": 9724,
	"./datamanagement-dark.svg": 3073,
	"./datamanagement-light-hover.svg": 9694,
	"./datamanagement-light.svg": 2423,
	"./devops-dark-hover.svg": 3714,
	"./devops-dark.svg": 8571,
	"./devops-light-hover.svg": 4844,
	"./devops-light.svg": 3009,
	"./direct-channels-dark-hover.svg": 8957,
	"./direct-channels-dark.svg": 872,
	"./direct-channels-light-hover.svg": 9709,
	"./direct-channels-light.svg": 904,
	"./fabrick-dark.svg": 9390,
	"./fabrick-light.svg": 5806,
	"./globe_icon.svg": 5556,
	"./greatplace-dark-hover.svg": 6031,
	"./greatplace-dark.svg": 4718,
	"./greatplace-light-hover.svg": 8319,
	"./greatplace-light.svg": 9438,
	"./greatplacetowork_icon.svg": 8467,
	"./headcount-dark-hover.svg": 3860,
	"./headcount-dark.svg": 9033,
	"./headcount-light-hover.svg": 8038,
	"./headcount-light.svg": 479,
	"./headcount_icon.svg": 7948,
	"./health.svg": 4179,
	"./hr-system-icon-hover.svg": 1822,
	"./hr-systems-dark-hover.svg": 7138,
	"./hr-systems-dark.svg": 8539,
	"./hr-systems-icon.svg": 996,
	"./hr-systems-light-hover.svg": 1132,
	"./hr-systems-light.svg": 1217,
	"./icon_about_people.svg": 7058,
	"./icon_aboutus_entrepreneurship.svg": 2416,
	"./icon_aboutus_ethics.svg": 6907,
	"./icon_aboutus_innovation.svg": 6810,
	"./icon_aboutus_openness.svg": 8670,
	"./icon_aboutus_trust.svg": 4027,
	"./icon_health.svg": 1311,
	"./icon_it_lang.svg": 3977,
	"./icon_parental.svg": 7682,
	"./icon_remotework.svg": 3892,
	"./icon_ro_lang.svg": 2643,
	"./icon_timeoff.svg": 2949,
	"./icon_upskill.svg": 5389,
	"./icon_valuepreposition_apifirst_dark.svg": 1294,
	"./icon_valuepreposition_apifirst_light.svg": 1246,
	"./icon_valuepreposition_cloudready_dark.svg": 2540,
	"./icon_valuepreposition_cloudready_light.svg": 4068,
	"./icon_valuepreposition_corebanking_dark.svg": 4741,
	"./icon_valuepreposition_corebanking_light.svg": 4323,
	"./icon_valuepreposition_dataai_dark.svg": 7966,
	"./icon_valuepreposition_dataai_light.svg": 9630,
	"./icon_workculture.svg": 8180,
	"./investments-dark-hover.svg": 1615,
	"./investments-dark.svg": 8974,
	"./investments-icon-hover.svg": 3652,
	"./investments-icon.svg": 7273,
	"./investments-light-hover.svg": 3071,
	"./investments-light.svg": 1790,
	"./linkedin-hover.svg": 5454,
	"./linkedin.svg": 4903,
	"./parental.svg": 7998,
	"./payments-dark-hover.svg": 6912,
	"./payments-dark.svg": 5717,
	"./payments-icon-hover.svg": 7963,
	"./payments-icon.svg": 7098,
	"./payments-light-hover.svg": 8826,
	"./payments-light.svg": 3507,
	"./quote_black.svg": 1463,
	"./quote_grey.svg": 1543,
	"./remotework.svg": 7944,
	"./sellaleasing-dark.svg": 5630,
	"./sellaleasing-light.svg": 6830,
	"./testimonial1.svg": 7507,
	"./testimonial2.svg": 6608,
	"./testing-dark-hover.svg": 2961,
	"./testing-dark.svg": 8812,
	"./testing-light-hover.svg": 3385,
	"./testing-light.svg": 244,
	"./timeoff.svg": 9913,
	"./upskill.svg": 3321,
	"./whoweare_grafic_dark.svg": 5683,
	"./whoweare_grafic_light.svg": 6841,
	"./workculture.svg": 8720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6567;